(function () {
  // Toggle debug:
  // window.__pp_debug = true;

  function log() {
    if (window.__pp_debug) {
      console.log.apply(console, arguments);
    }
  }

  /* =========================================================
     1. Prevent double-click add-to-cart (safe method)
     ========================================================= */

  document.addEventListener("click", function (e) {
    const btn = e.target.closest('button[name="add"]');
    if (!btn) return;

    if (btn.dataset.ppProcessing === "true") {
      e.preventDefault();
      e.stopImmediatePropagation();
      log("Blocked duplicate ATC click");
      return;
    }

    btn.dataset.ppProcessing = "true";

    setTimeout(() => {
      btn.dataset.ppProcessing = "false";
    }, 800);
  }, true); // capture phase so it runs before Dawn

  /* =========================================================
     2. Open drawer after successful add
     ========================================================= */

  document.addEventListener("cart:updated", function () {
    log("Cart updated event detected");

    const drawer =
      document.querySelector("cart-drawer") ||
      document.getElementById("CartDrawer");

    if (!drawer) return;

    if (typeof drawer.open === "function") {
      drawer.open();
    }
  });

})();